var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('LoadingBox'):_vm._e(),_c('CoursesList',{attrs:{"courses":_vm.courses,"isBusy":_vm.isBusy},on:{"next":_vm.fetchUserCourseHistory},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var course = ref.course;
return [_c('CourseThumbWithProgress',{attrs:{"course":course}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }